<template>
  <div class="ticket-message-input">
    <div class="body-container">
      <template v-if="isRichText">
        <vue-editor
          v-model.lazy="richText"
          :placeholder="$t('general.enterYourMessage')"
          class="rich-text-editor"
          :editor-toolbar="customToolbar"
        />
      </template>
      <template v-else>
        <b-form-textarea
          id="textarea"
          v-model.lazy="normalText"
          :class="
            $browserDetect.isChrome
              ? 'custom-input-text-chrome'
              : 'custom-input-text'
          "
          :placeholder="$t('general.enterYourMessage')"
          rows="2"
          max-rows="2"
          no-resize
          type="text"
          required
          @focus="onInputFocus"
          @keydown.enter.exact.prevent="handleSubmit"
        />

        <!--        <b-form-textarea-->
        <!--          ref="inputBox"-->
        <!--          v-model="text"-->
        <!--          rows="2"-->
        <!--          max-rows="2"-->
        <!--          no-resize-->
        <!--          trim-->
        <!--          :placeholder="$t('general.enterYourMessage')"-->
        <!--          @keydown.enter.exact.prevent="sendMessage"-->
        <!--        />-->
      </template>
    </div>
    <div class="footer-container">
      <div class="left-container">
        <toggle-button
          v-model="internalSwitch"
          v-b-tooltip.hover
          :sync="true"
          style="margin-top: 0.25em"
          :color="{
            checked: '#8D5185',
            unchecked: '#E2E2E2',
            disabled: '#EBE4EA',
          }"
          :title="`${$t('ticket.internal_note')} ${$t(
            internalSwitch ? 'ticket.open' : 'ticket.close'
          )}`"
          :width="36"
          :height="18"
          :disabled="loading.isUpdating"
          @change="$emit('internalSwitchChange', internalSwitch)"
        />
        <!--        <b-form-checkbox-->
        <!--          v-model="internalSwitch"-->
        <!--          v-b-tooltip.hover-->
        <!--          :title="`${$t('ticket.internal_note')} ${ $t(internalSwitch ? 'ticket.open' : 'ticket.close')}`"-->
        <!--          name="check-button"-->
        <!--          switch-->
        <!--          :disabled="loading.isUpdating"-->
        <!--          @change="$emit('internalSwitchChange', internalSwitch)"-->
        <!--        >-->
        <!--          <span>{{-->
        <!--            loading.isUpdating ? "Please wait..." : "Internal Note"-->
        <!--          }}</span>-->
        <!--        </b-form-checkbox>-->
        <section class="input-section">
          <template v-if="isRichText">
            <feather-icon
              v-b-tooltip.hover
              :title="$t('ticket.normal_text')"
              class="clickable-icon"
              icon="Edit2Icon"
              size="20"
              @click="[(isRichText = false), (ticketStore.isRichText = false)]"
            />
          </template>

          <template v-else>
            <feather-icon
              v-b-tooltip.hover
              :title="$t('ticket.rich_text')"
              class="clickable-icon"
              icon="EditIcon"
              size="20"
              @click="[(isRichText = true), (ticketStore.isRichText = true)]"
            />
          </template>
        </section>
      </div>
      <div class="right-container">
        <template v-if="isRichText">
          <b-button
            :class="
              // richText.length > 0 && !ticketStore.loading.isSending
              richText.length > 0
                ? 'button-submit button-submit-active'
                : 'button-submit button-submit-inactive'
            "
            variant="primary"
            size="sm"
            :disabled="richText === ''"
            @click="handleSubmit"
          >
            <!--            {{-->
            <!--              ticketStore.loading.isSending ? "Sending..." : $t("ticket.submit")-->
            <!--            }}-->
            {{ $t("ticket.submit") }}
          </b-button>
        </template>
        <template v-else>
          <div class="">
            <b-button
              :class="
                // normalText.length > 0 && !ticketStore.loading.isSending
                normalText.length > 0
                  ? 'button-submit button-submit-active'
                  : 'button-submit button-submit-inactive'
              "
              variant="primary"
              size="sm"
              :disabled="normalText === ''"
              @click="handleSubmit"
            >
              <!--              {{-->
              <!--                $t(ticketStore.loading.isSending ? 'Sending...' : 'ticket.submit')-->
              <!--              }}-->
              {{ $t("ticket.submit") }}
            </b-button>
          </div>
        </template>

        <!--        <b-button-->
        <!--          :class="-->
        <!--            richText.length > 0 && !ticketStore.loading.isSending-->
        <!--              ? 'button-submit button-submit-active'-->
        <!--              : 'button-submit button-submit-inactive'-->
        <!--          "-->
        <!--          variant="primary"-->
        <!--          :disabled="richText === ''"-->
        <!--          @click="handleSubmit"-->
        <!--        >-->
        <!--          {{-->
        <!--            ticketStore.loading.isSending ? 'Sending...' : $t('ticket.submit')-->
        <!--          }}-->
        <!--        </b-button>-->
        <!--        <template v-if="isRichText">-->
        <!--          <b-button-->
        <!--            :class="richText.length > 0 ? 'button-submit button-submit-active': 'button-submit button-submit-inactive'"-->
        <!--            variant="primary"-->
        <!--            :disabled="richText === ''"-->
        <!--            @click="handleSubmit"-->
        <!--          >-->
        <!--            {{ ticketStore.loading.isSending ? "Sending...":$t("ticket.submit") }}-->
        <!--          </b-button>-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <b-button-->
        <!--            :class="normalText.length > 0 ? 'button-submit button-submit-active': 'button-submit button-submit-inactive'"-->
        <!--            variant="primary"-->
        <!--            :disabled="normalText === ''"-->
        <!--            @click="handleSubmit"-->
        <!--          >-->
        <!--            {{ ticketStore.loading.isSending ? "Sending...":$t("ticket.submit") }}-->
        <!--          </b-button>-->
        <!--        </template>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormTextarea,
  BButton,
  BFormCheckbox,
  BTooltip,
  BSpinner,
} from "bootstrap-vue";
import { computed, nextTick, ref } from "@vue/composition-api";
import { VueEditor } from "vue2-editor";
import useTicketStore from "@/store-pinia/useTicketStore";

export default {
  components: {
    BFormTextarea,
    BButton,
    BFormCheckbox,
    BSpinner,
    BTooltip,
    VueEditor,
  },
  props: {
    operationName: {
      type: String,
      default: "Name",
    },
    internalSwitch: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Object,
      default: () => ({
        isUpdating: false,
        isSubmitting: false,
      }),
    },
  },

  setup(props, { emit }) {
    const ticketStore = useTicketStore();
    const isRichText = computed(() => ticketStore.isRichText);
    const normalText = ref("");
    const richText = ref("");
    const customToolbar = ref([
      [{ font: [] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["blockquote"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      // ['link', 'image'],
    ]);
    // const internalSwitch = ref(ticketStore.getSelectedTicket)
    function resetForm() {
      normalText.value = "";
      richText.value = "";
    }

    function isChrome() {
      return agentHas("CriOS") || agentHas("Chrome") || !!window.chrome;
    }

    function handleSubmit() {
      const submitValue = isRichText.value ? richText.value : normalText.value;

      if (submitValue !== "") {
        // operationName
        // emit("submit",  submitValue );
        emit("submit", {
          message: submitValue,
          operatorName: props.operationName,
        });
        nextTick(() => {
          resetForm();
        });
      }
    }

    function handleSubmitWithKey() {
      let submitValue = isRichText.value ? richText.value : normalText.value.trim();

      if (/^\s/.test(submitValue)) submitValue = "";

      console.log(submitValue);
      if (!submitValue) {
        emit("submit", isRichText.value ? richText.value : normalText.value);
        nextTick(() => {});
        resetForm();
      } else {
        resetForm();
      }
    }

    function onInputFocus(ev) {
      ev.preventDefault();
    }

    return {
      ticketStore,
      isRichText,
      normalText,
      richText,
      resetForm,
      handleSubmit,
      handleSubmitWithKey,
      onInputFocus,
      // internalSwitch,
      customToolbar,
      isChrome,
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-message-input {
  //border: 1px solid #ebe9f1;
  .clickable-icon {
    cursor: pointer;
  }

  .body-container {
    //padding-right: 1em;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    gap: 2em;
  }

  .footer-container {
    padding: 0.5em;
    border-top: 1px solid #ebe9f1;
    display: flex;
    justify-content: space-between;

    .left-container {
      //margin-top: 0.5em;
      display: flex;
      gap: 1em;
    }

    .right-container {
    }
  }
}

.button-submit {
  transition: all 0.25s ease-in-out;
}

.button-submit-active {
  visibility: visible;
  opacity: 1;
}

.button-submit-inactive {
  visibility: hidden;
  opacity: 0;
}

.custom-input-text-chrome {
  border: unset;
  &:focus {
    box-shadow: unset;
  }
  margin-bottom: 1em;
  //padding-bottom: 1em;
}
.custom-input-text {
  border: unset;
}

.custom-input-text:focus {
  //outline: 1px solid #8d5185;
  //outline-offset: -0.5em;
  box-shadow: unset;
}

.custom-control-label {
  margin-bottom: unset;
}
.rich-text-editor {
  border: unset;
  width: 100%;
}
.custom-checkbox {
  //width: 0px;
}
.vue-js-switch {
  margin-bottom: 0;
}
</style>
